export default __webpack_public_path__ + "static/media/attachment-blue-icon.2a08919f.svg";